import { GridLayout, GridLayoutItem } from '@progress/kendo-react-layout';
import { Wrapper } from 'app/components/SHToolTip';
import styled from 'styled-components';
import SeasonImage from './Components/Icons/settings.svg';
import ProfileImage from './Components/Icons/Profile.png';
import { useNavigate } from 'react-router-dom';
import FileIcon from '../../../assets/icon/FileIcon.svg';
import backNumberIcon from '../../../assets/icon/backNumber.svg';
import feeIcon from '../../../assets/icon/fee.svg';
import { usePermission } from 'hooks/usePermission';

const SettingsCard = () => {
  const navigate = useNavigate();
  const { hasViewPermission } = usePermission();
  const handleProfileClick = () => {
    navigate(`/admin/settings/profile-settings`);
  };
  const handleSeasonClick = () => {
    navigate(`/admin/settings/seasonSettings`);
  };
  const handleRolesClick = () => {
    navigate(`/admin/settings/roles`);
  };
  const handleBackNumberClick = () => {
    navigate(`/admin/settings/back-number-management`);
  };
  const handleFeeClick = () => {
    navigate(`/admin/settings/fee-management`);
  };
  const handleImageBackgroundClick = () => {
    navigate(`/admin/settings/image-management`);
  };
  const handleDocumentImageManagementClick = () => {
    navigate(`/admin/settings/document-image-management`);
  };
  return (
    <MainWrapper>
      <GridLayout
        gap={{ rows: 20, cols: 20 }}
        rows={[{ height: 'auto' }, { height: 'auto' }]}
        cols={[
          { width: 'calc(33.33% - 7px)' },
          { width: 'calc(33.33% - 7px)' },
          { width: 'calc(33.33% - 7px)' },
        ]}
        style={{ marginTop: '20px' }}
      >
        <GridLayoutItem row={1} colSpan={1} className="first-item">
          <ContentWrapper onClick={handleProfileClick} className="season-style">
            <img src={ProfileImage} alt="profile" />
            <p>Profile Settings</p>
          </ContentWrapper>
        </GridLayoutItem>
        {hasViewPermission('0900101002') && (
          <GridLayoutItem row={1} colSpan={1} className="first-item">
            <ContentWrapper
              onClick={handleSeasonClick}
              className="season-style"
            >
              <img src={SeasonImage} alt="Season" />
              <p>Season Settings</p>
            </ContentWrapper>
          </GridLayoutItem>
        )}

        {hasViewPermission('0900101004') && (
          <GridLayoutItem row={1} colSpan={1} className="first-item">
            <ContentWrapper onClick={handleRolesClick} className="season-style">
              <img src={FileIcon} alt="profile" />
              <p>Roles</p>
            </ContentWrapper>
          </GridLayoutItem>
        )}

        {hasViewPermission('0900101012') && (
          <GridLayoutItem row={2} colSpan={1} className="first-item">
            <ContentWrapper
              onClick={handleBackNumberClick}
              className="season-style"
            >
              <img src={backNumberIcon} alt="backnumber" />
              <p>Back Number Management</p>
            </ContentWrapper>
          </GridLayoutItem>
        )}
        {hasViewPermission('0900101011') && (
          <GridLayoutItem row={2} colSpan={1} className="first-item">
            <ContentWrapper onClick={handleFeeClick} className="season-style">
              <img src={feeIcon} alt="fee" />
              <p>Fee Management</p>
            </ContentWrapper>
          </GridLayoutItem>
        )}
        {hasViewPermission('0900101015') && (
          <GridLayoutItem row={2} colSpan={1} className="first-item">
            <ContentWrapper onClick={handleImageBackgroundClick} className="season-style">
              <svg width="150" height="150" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="12" y="14" width="40" height="36" rx="2" stroke="black" strokeWidth="2" fill="none" />
                <circle cx="24" cy="24" r="4" stroke="black" strokeWidth="2" fill="none" />
                <path d="M12 40L24 28L36 38L52 22" stroke="black" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
              <p>Background Image Management</p>
            </ContentWrapper>
          </GridLayoutItem>
        )}
        {hasViewPermission('0900101016') && (
          <GridLayoutItem row={3} colSpan={1} className="first-item">
            <ContentWrapper onClick={handleDocumentImageManagementClick} className="season-style">
              <svg width="150" height="150" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16 12H42L52 22V52H16V12Z" stroke="black" strokeWidth="2" fill="none" />
                <path d="M42 12V22H52" stroke="black" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
                <line x1="22" y1="30" x2="46" y2="30" stroke="black" strokeWidth="2" strokeLinecap="round" />
                <line x1="22" y1="38" x2="46" y2="38" stroke="black" strokeWidth="2" strokeLinecap="round" />
                <line x1="22" y1="46" x2="38" y2="46" stroke="black" strokeWidth="2" strokeLinecap="round" />
              </svg>
              <p>Document Image Management</p>
            </ContentWrapper>
          </GridLayoutItem>
        )}
        {/* Team Settings is commented since it is not used now, but can be used in future  */}

        {/* <GridLayoutItem row={1} col={3} colSpan={1} className="first-item">  
          <ContentWrapper>
            <img src={TeamImage} alt="team" />
            <p>Team Settings</p>
          </ContentWrapper>
        </GridLayoutItem>  */}
      </GridLayout>
    </MainWrapper>
  );
};

export default SettingsCard;
const MainWrapper = styled(Wrapper)`
  .profile-img {
    display: none;
  }
  .border-div {
    display: none;
  }
`;
const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  border: 1px solid #caced8;
  padding: 30px;
  border-radius: 12px;
  cursor: pointer;
  height: 100%;

  img {
    max-width: 100%;
    height: auto;
    margin-bottom: 10px;
    max-width: 120px;
    width: 100%;
  }

  p {
    margin: 0;
    font-size: 15px;
    font-family: 'Inter';
    letter-spacing: 0.1px;
    font-weight: 700;
    padding: 10px 0 0 0;
  }
`;
